/* global __webpack_require__ */

// Phones drop chunk downloads mid-load (FLOCKNOTE-REACT-TY2 / CRJ), and React.lazy
// never retries a failed import, so one dropped request blanked the whole app.
const RETRY_DELAYS_MS = [400, 1500];

const isChunkLoadError = (error) =>
  error?.name === "ChunkLoadError" || error?.code === "CSS_CHUNK_LOAD_FAILED";

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Wraps a webpack chunk handler (`__webpack_require__.f.*`) so a failed download
 * gets requested again. Both webpack's JS loader and mini-css-extract-plugin forget
 * a chunk that failed, so calling the handler again starts a fresh request.
 */
export function withChunkRetries(handler, delays = RETRY_DELAYS_MS) {
  const load = (attempt, chunkId, ...rest) => {
    const pending = [];
    handler(chunkId, pending, ...rest);

    return Promise.all(pending).catch((error) => {
      if (attempt >= delays.length || !isChunkLoadError(error)) throw error;
      return wait(delays[attempt]).then(() =>
        load(attempt + 1, chunkId, ...rest)
      );
    });
  };

  return (chunkId, promises, ...rest) => {
    promises.push(load(0, chunkId, ...rest));
  };
}

/**
 * Call once at startup, before anything lazy renders.
 *
 * Wraps the handlers in `__webpack_require__.f`, not `__webpack_require__.e`: under
 * hot reload every module gets its own copy of `.e`, but `.f` is shared, so this
 * covers dev and prod alike.
 */
export default function retryChunkLoads() {
  if (typeof __webpack_require__ === "undefined") return;

  const handlers = __webpack_require__.f;
  ["j", "miniCss"].forEach((key) => {
    if (handlers[key]) handlers[key] = withChunkRetries(handlers[key]);
  });
}
